import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Näita vähem

  <span style="color:#85c1dc;">**FI:**</span>
  Näytä vähemmän

  <span style="color:#85c1dc;">**RU:**</span>
  Показать меньше
*/
/* @__NO_SIDE_EFFECTS__ */
const m1667 = msg(
  mf`Näita vähem`,
  mf`Näytä vähemmän`,
  mf`Показать меньше`,
)

export { m1667 as 'w.module.filter_bar.show_less' }